import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      team: 'Équipe',
      services: 'Services',
      reviews: 'Avis',
      gallery: 'Galerie',
      contact: 'Contact'
    },
    hero: {
      title1: "L'art de la coiffure",
      title2: "masculine",
      subtitle: "Fade, Taper, Design - Des coupes précises et modernes par des barbiers passionnés",
      bookNow: "Réserver maintenant",
      call: "Appeler",
      address: "2911 Rue Allard, Montréal",
      hours: "Mar-Dim: 10h-19h"
    },
    team: {
      badge: "NOTRE ÉQUIPE",
      title: "Nos",
      titleAccent: "Maîtres Barbiers",
      subtitle: "Une équipe passionnée et talentueuse dédiée à votre style",
      years: "ans"
    },
    services: {
      badge: "NOS SERVICES PREMIUM",
      title: "Liste de",
      titleAccent: "Prix",
      subtitle: "Des coupes modernes et précises adaptées à votre style",
      bookAppointment: "Réserver un rendez-vous maintenant",
      duration: "durée"
    },
    reviews: {
      badge: "AVIS CLIENTS",
      title: "Ce que nos",
      titleAccent: "clients disent",
      subtitle: "Des centaines de clients satisfaits nous font confiance",
      rating: "Note moyenne: 5.0/5",
      satisfied: "500+ clients satisfaits"
    },
    gallery: {
      badge: "NOTRE PORTFOLIO",
      title: "Nos",
      titleAccent: "Réalisations",
      subtitle: "Découvrez quelques-unes de nos meilleures coupes et créations"
    },
    contact: {
      badge: "CONTACT",
      title: "Venez nous",
      titleAccent: "rendre visite",
      subtitle: "Notre équipe vous attend dans notre salon moderne au cœur de Montréal",
      address: "Adresse",
      phone: "Téléphone",
      hours: "Horaires",
      directions: "Itinéraire",
      call: "Appeler",
      sendEmail: "Envoyer un email"
    },
    footer: {
      navigation: "Navigation",
      contact: "Contact",
      description: "Votre destination pour des coupes modernes et professionnelles à Montréal.",
      rights: "Tous droits réservés",
      poweredBy: "Propulsé par"
    },
    days: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
      closed: "Fermé"
    }
  },
  en: {
    nav: {
      home: 'Home',
      team: 'Team',
      services: 'Services',
      reviews: 'Reviews',
      gallery: 'Gallery',
      contact: 'Contact'
    },
    hero: {
      title1: "The art of",
      title2: "masculine grooming",
      subtitle: "Fade, Taper, Design - Precise and modern cuts by passionate barbers",
      bookNow: "Book Now",
      call: "Call",
      address: "2911 Rue Allard, Montreal",
      hours: "Tue-Sun: 10am-7pm"
    },
    team: {
      badge: "OUR TEAM",
      title: "Our",
      titleAccent: "Master Barbers",
      subtitle: "A passionate and talented team dedicated to your style",
      years: "years"
    },
    services: {
      badge: "PREMIUM SERVICES",
      title: "Price",
      titleAccent: "List",
      subtitle: "Modern and precise cuts tailored to your style",
      bookAppointment: "Book an appointment now",
      duration: "duration"
    },
    reviews: {
      badge: "CLIENT REVIEWS",
      title: "What our",
      titleAccent: "clients say",
      subtitle: "Hundreds of satisfied clients trust us",
      rating: "Average rating: 5.0/5",
      satisfied: "500+ satisfied clients"
    },
    gallery: {
      badge: "OUR PORTFOLIO",
      title: "Our",
      titleAccent: "Work",
      subtitle: "Discover some of our best cuts and creations"
    },
    contact: {
      badge: "CONTACT",
      title: "Come",
      titleAccent: "visit us",
      subtitle: "Our team awaits you in our modern salon in the heart of Montreal",
      address: "Address",
      phone: "Phone",
      hours: "Hours",
      directions: "Directions",
      call: "Call",
      sendEmail: "Send an email"
    },
    footer: {
      navigation: "Navigation",
      contact: "Contact",
      description: "Your destination for modern and professional haircuts in Montreal.",
      rights: "All rights reserved",
      poweredBy: "Powered by"
    },
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      closed: "Closed"
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
